const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://thilak.lyricstelugu.in',
  title: 'Thilak Kumar.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'M. Thilak Kumar',
  role: 'MERN Stack Web Developer',
  picture: 'https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png',

  description:
    'Skilled in building responsive and dynamic web applications using MongoDB, Express.js, React, and Node.js. Proficient in designing RESTful APIs, managing databases, and developing user-friendly front-end interfaces. Strong problem-solving skills with a focus on clean, scalable, and maintainable code..',
  resume: 'https://drive.google.com/file/d/1Y8o8K6wEVzlTabEIMvQxRk8zGkTcKXyf/view?usp=sharing',
  social: {
    linkedin: 'https://linkedin.com',
    github: 'https://github.com',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'To Do Application',
    description:
      'Its an application to save the todo task for daily life',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://todoappthilak.ccbp.tech/',
    //image: 'cleanfolio.png',
  },
  {
    name: 'Bookmark Maker',
    description:
      'We can bookmark favourite website through this application',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'bookmarkthilak.ccbp.tech',
    //image: 'https://github.githubassets.com/assets/GitHub-Logo-ee398b662d42.png',
  },
  {
    name: 'Cowin Dashboard',
    description:
      'Its an application which updates daily and it wiil provide the information about the Covid actives cases',
    stack: ['HTML', 'CSS', 'Figma'],
    sourceCode: 'https://github.com',
    livePreview: 'https://cowinthilak.ccbp.tech',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'HTML',
  'CSS',
  'JavaScript',
  'React',
  'Redux',
  'SASS',
  'Material UI',
  'Git',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'malothuthilak@gmail.com',
}

export { header, about, projects, skills, contact }